import { Box } from "@mui/material";
import { createRef, useEffect, useMemo, useState } from "react";
import { Form } from "react-final-form";
import FormContent from "./FormContent";

/**
 * Cria um objeto que permite submeter o formulário.
 */
export function useFormApi() {
    const [form] = useState({
        // HTML tag ref.
        ref: null,

        // React Final Form API.
        api: null,

        getValues() {
            if (this.api) {
                return this.api.getState().values;
            }
        },

        submit() {
            if (this.ref) {
                this.ref.current.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
            }
        },
    });

    return form;
}

/**
 * Um formulário para uso geral na aplicação.
 */
export default function FForm({ initialValues, onSubmit, onChange, formApi, contentProps, sx, children, ...props }) {
    const formRef = createRef();
    // Armazena os valores em um memo para evitar reloads na mesma entidade.
    const values = useMemo(() => initialValues, [initialValues]);

    useEffect(() => {
        if (formApi) {
            formApi.ref = formRef;
        }
    }, [formApi, formRef]);

    function handleSubmit(...args) {
        if (onSubmit) {
            onSubmit(...args);
        }
    }

    return (
        <Box sx={{ flex: 1 }}>
            <Form onSubmit={handleSubmit} initialValues={values} {...props} >
                {(formProps) => {
                    if (formApi) {
                        formApi.api = formProps.form;
                    }

                    if (onChange) {
                        // Passa o estado e a api do formulário para o evento.
                        formProps.form.subscribe((state) => onChange({ ...state, form: formProps.form }), {
                            values: true,
                        });
                    }

                    return (
                        <form ref={formRef} onSubmit={formProps.handleSubmit} {...props}>
                            <FormContent {...contentProps}>{children}</FormContent>
                        </form>
                    );
                }}
            </Form>
        </Box>
    );
}
